//import Moment from "moment";

const getCount = (state) => {
	return state.familias.length;
}

export default {
	getCount
}